module.exports = __webpack_public_path__ + "static/media/steve-1979.372da064.jpg";